import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    pickUpAddress: '',
    dropOffAddress: '',
    pickUp: 0,
    dropOff: 0,
    tripType: '2',
    noOfPassengers: 1,
    departureDate: '',
    departureTime: '',
    departureUnix: 0,
    returnDate: '',
    returnTime: '',
    returnUnix: 0,
    gclid: '',
    // Form source tracking
    formSource: '',
    // Raw Form 1 data object (before any conversions)
    rawForm1Data: null,
};

const bookingSlice = createSlice({
    name: 'booking',
    initialState,
    reducers: {
        setBookingDetails: (state, action) => {
            return { ...state, ...action.payload };
        },
        clearBookingForm: (state) => {
            return initialState;
        },
        updateField: (state, action) => {
            const { field, value } = action.payload;
            state[field] = value;
        },
        hydrateFromStorage: (state, action) => {
            // Safely merge persisted state with current state
            if (action.payload && typeof action.payload === 'object') {
                return { ...state, ...action.payload };
            }
            return state;
        },
    },
});

export const { setBookingDetails, clearBookingForm, updateField, hydrateFromStorage } = bookingSlice.actions;
export default bookingSlice.reducer; 